import { Module } from 'vuex'
import { getActivityUserInfo, getActivityInfo } from '@/apis/old-brings-new'

interface OldBringsNewState {
  inviteCode: string // 邀请码
  bindInviteCode: string // 绑定的邀请码
  isNewUser: boolean // 是否新用户
  activityGuid: string // 活动guid
}

const oldBringsNew: Module<OldBringsNewState, any> = {
  namespaced: true,
  state: function () {
    return {
      inviteCode: '',
      bindInviteCode: '',
      isNewUser: false,
      activityGuid: '',
    }
  },
  mutations: {
    setUserInfo(
      state,
      payload: Partial<Pick<OldBringsNewState, 'inviteCode' | 'bindInviteCode' | 'isNewUser'>>
    ) {
      if (payload.inviteCode !== undefined) state.inviteCode = payload.inviteCode
      if (payload.bindInviteCode !== undefined) state.bindInviteCode = payload.bindInviteCode
      if (payload.isNewUser !== undefined) state.isNewUser = payload.isNewUser
    },
    setActivityInfo(state, payload: Partial<Pick<OldBringsNewState, 'activityGuid'>>) {
      if (payload.activityGuid !== undefined) state.activityGuid = payload.activityGuid
    },
  },
  actions: {
    async updateUserInfo({ commit }) {
      const userInfoRes = await getActivityUserInfo()
      commit('setUserInfo', {
        inviteCode: userInfoRes.invite_code,
        bindInviteCode: userInfoRes.bind_invite_code,
        isNewUser: userInfoRes.is_new_user,
      })
    },
    async updateActivityInfo({ commit }) {
      const activityInfoRes = await getActivityInfo()
      commit('setActivityInfo', {
        activityGuid: activityInfoRes.guid,
      })
    },
    async initCommonInfo({ dispatch }) {
      await Promise.all([dispatch('updateUserInfo'), dispatch('updateActivityInfo')])
    },
  },
}

export default oldBringsNew
